var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 248,
    width: 32,
    height: 33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-752 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8667 17.7667C19 18.6667 20.0667 20.2333 20.8667 22L11.1333 22C11.9667 20.2333 13 18.6333 14.1333 17.7667 14.6667 17.3333 15 16.7 15 16 15 15.3 14.6667 14.6667 14.1333 14.2333 11.8667 12.4667 9.9 7.93333 9.56667 4.66667L22.4667 4.66667C22.1 7.93333 20.1667 12.4667 17.9 14.2333 17.3333 14.6667 17 15.3 17 16 17 16.7 17.3333 17.3333 17.8667 17.7667ZM24.4333 4.66667 25.3333 4.66667 25.3333 2.66667 6.66667 2.66667 6.66667 4.66667 7.53333 4.66667C7.9 8.36667 10.0333 13.7667 13.1333 16 10.0333 18.2333 7.86667 23.6333 7.53333 27.3333L6.66667 27.3333 6.66667 29.3333 25.3333 29.3333 25.3333 27.3333 24.4333 27.3333C24.1 23.6333 21.9333 18.2333 18.8333 16 21.9333 13.7667 24.1 8.36667 24.4333 4.66667Z",
    fill: "#A6A6A6",
    transform: "matrix(1 0 0 1.03125 752 248)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordLogo);
export default __webpack_public_path__ + "static/media/record-logo.f4f02f3ba1acc4bb82210e4722b4428c.svg";
export { ForwardRef as ReactComponent };